import { useQuery } from '@tanstack/react-query';
import EventApi from '../apis/event_api';

export const eventKeys = {
  all: ['events'] as const,
  byId: (id: number) => [...eventKeys.all, id] as const,
};

export function useEvents() {
  return useQuery({
    queryKey: eventKeys.all,
    queryFn: async () => await EventApi.getEventsForUser(),
  });
}

export function useEvent(id: number) {
  return useQuery({
    queryKey: eventKeys.byId(id),
    queryFn: async () => await EventApi.getEventById(id),
    enabled: !!id,
  });
}
